import React from 'react';
import { ArrowRight, Users, Building2, Zap, CheckCircle, ChevronDown, Menu, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "./components/ui/card";
import ProjectsPage from './pages/projects';
import ServicesPage from './pages/services';
import HomePage from './pages/home';
import AboutPage from './pages/aboutus';
import ContactPage from './pages/contact';
import NavBar from './pages/navbar';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

const pageTransition = {
  initial: {
    opacity: 0,
    x: -200
  },
  animate: {
    opacity: 1,
    x: 0
  },
  exit: {
    opacity: 0,
    x: 200
  }
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageTransition}
        transition={{ duration: 0.3 }}
      >
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

const Website = () => {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <NavBar />
        <div className="pt-16">
          <AnimatedRoutes />
        </div>
      </div>
    </Router>
  );
};

export default Website;
